import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ModalComponent } from './components/modal/modal.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { MessageComponent } from './components/message/message.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { UnsavedChangesModalComponent } from './components/unsaved-changes-modal/unsaved-changes-modal.component';
import { TableComponent } from './components/table/table.component';
import { ButtonComponent } from './components/button/button.component';
import { DashComponentComponent } from './components/dash-component/dash-component.component';
import { FormShellComponent } from './components/form-shell/form-shell.component';
import { LoadingModule } from './components/loading/loading.module';
import { HasAnchorDirective } from './directives/has-anchor.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { BrazilDatePipe } from './pipes/brazil-date.pipe';
import { SensitiveCurrencyComponent } from './components/sensitive-currency/sensitive-currency.component';

@NgModule({
  declarations: [
    ModalComponent,
    SideMenuComponent,
    ErrorModalComponent,
    MessageComponent,
    ConfirmationModalComponent,
    UnsavedChangesModalComponent,
    TableComponent,
    ButtonComponent,
    DashComponentComponent,
    FormShellComponent,
    HasAnchorDirective,
    HasPermissionDirective,
    BrazilDatePipe,
    SensitiveCurrencyComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LoadingModule
  ],
  exports: [
    ModalComponent,
    SideMenuComponent,
    ErrorModalComponent,
    MessageComponent,
    ConfirmationModalComponent,
    UnsavedChangesModalComponent,
    TableComponent,
    ButtonComponent,
    DashComponentComponent,
    FormShellComponent,
    HasAnchorDirective,
    HasPermissionDirective,
    BrazilDatePipe,
    SensitiveCurrencyComponent,
    LoadingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [
    DatePipe
  ]
})
export class SharedModule { }
